export default {
  currentVersion: 'current version',
  selectVersion: 'Select version',
  goToCurrentVersion: 'Go to current version (v{version})',
  versionDeployed: 'Deployed on {date}'
}
